/**
 * Design tokens lifted from Alex's Wireframes v2.
 *
 * The boards use their own flat palette rather than the app theme. Keeping the
 * exact values here makes the build reviewable against the wireframe, and gives
 * one place to swap when this moves onto the app's design system.
 */

export const wf = {
  ink: '#1f2328',
  muted: '#6b7280',
  faint: '#b0b5bc',
  line: '#d6d9de',
  lineSoft: '#eceef1',
  surface: '#ffffff',
  surfaceAlt: '#f6f7f8',
  blue: '#2a5db0',
  blueSoft: '#e8eefb',
  purple: '#6d4aff',
  purpleSoft: '#f7f5ff',
  amber: '#8a5a00',
  amberSoft: '#fdf6e3',
  amberWarn: '#b45309',
  amberWarnSoft: '#fff4e5',
  green: '#2e7d32',
  greenSoft: '#e7f2e8',
  red: '#a63244',
  redSoft: '#fdeeee',
  track: '#e6e8ec',
} as const;

/** Card container from the boards. */
export const cardSx = {
  border: `1px solid ${wf.line}`,
  borderRadius: '8px',
  padding: '14px 16px',
  backgroundColor: wf.surface,
} as const;

export const greyCardSx = {
  ...cardSx,
  backgroundColor: wf.surfaceAlt,
  color: wf.muted,
} as const;

/** Group header text. */
export const groupTitleSx = {
  fontSize: '14px',
  fontWeight: 650,
  color: wf.ink,
} as const;

export type ChipTone = 'mut' | 'ok' | 'sug' | 'rev' | 'pend';

export const chipSx = (tone: ChipTone) => {
  const tones: Record<ChipTone, object> = {
    mut: { background: wf.surfaceAlt, color: wf.muted, border: `1px solid ${wf.line}` },
    ok: { background: wf.greenSoft, color: wf.green, border: '1px solid transparent' },
    sug: { background: wf.amberSoft, color: wf.amber, border: `1px solid ${wf.amber}` },
    rev: { background: wf.redSoft, color: wf.red, border: '1px solid transparent' },
    pend: {
      background: wf.amberWarnSoft,
      color: wf.amberWarn,
      border: `1px dashed ${wf.amberWarn}`,
    },
  };
  return {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '10px',
    fontWeight: 650,
    borderRadius: '10px',
    padding: '2px 8px',
    whiteSpace: 'nowrap',
    ...tones[tone],
  };
};
